import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Loader2 } from 'lucide-react';
import { legalAPI } from '../lib/api';

/**
 * Toont een van de drie juridische documenten. Welke, komt uit de route:
 * /voorwaarden, /verwerkersovereenkomst en /privacybeleid gebruiken dezelfde
 * component met een ander docType.
 */
export const LegalPage = ({ docType }) => {
  const [doc, setDoc] = useState(null);
  const [status, setStatus] = useState('bezig');

  useEffect(() => {
    let actief = true;
    (async () => {
      setStatus('bezig');
      try {
        const { data } = await legalAPI.getDocument(docType);
        if (actief) { setDoc(data); setStatus('klaar'); }
      } catch (e) {
        if (actief) setStatus('mislukt');
      }
    })();
    return () => { actief = false; };
  }, [docType]);

  const datum = (v) => (v ? new Date(v).toLocaleDateString('nl-BE', {
    day: 'numeric', month: 'long', year: 'numeric',
  }) : '');

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-[#1A4D2E] hover:underline mb-6">
          <ArrowLeft className="w-4 h-4" /> Terug naar FoodFlows
        </Link>

        <div className="bg-white rounded-2xl border border-gray-200 p-8" data-testid={`legal-${docType}`}>
          {status === 'bezig' && (
            <div className="py-16 text-center text-gray-500">
              <Loader2 className="w-6 h-6 animate-spin mx-auto mb-3" />
              Document laden…
            </div>
          )}

          {status === 'mislukt' && (
            <div className="py-16 text-center">
              <FileText className="w-10 h-10 text-gray-400 mx-auto mb-3" />
              <p className="text-gray-700 font-medium">Dit document is nog niet beschikbaar</p>
            </div>
          )}

          {status === 'klaar' && doc && (
            <>
              <div className="flex flex-wrap items-baseline justify-between gap-2 border-b border-gray-200 pb-4 mb-6">
                <h1 className="font-heading text-3xl font-bold text-gray-900">{doc.title}</h1>
                <p className="text-sm text-gray-500">
                  Versie {doc.version} · geldig sinds {datum(doc.effective_from)}
                </p>
              </div>

              {doc.is_placeholder && (
                <div className="mb-6 rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900">
                  Dit is een voorlopige tekst. De definitieve juridische versie volgt
                  en krijgt een eigen versienummer.
                </div>
              )}

              <div className="blog-content" dangerouslySetInnerHTML={{ __html: doc.content_html }} />
            </>
          )}
        </div>

        <div className="mt-6 flex flex-wrap gap-4 text-sm text-gray-600">
          <Link to="/voorwaarden" className="hover:underline">Algemene voorwaarden</Link>
          <Link to="/verwerkersovereenkomst" className="hover:underline">Verwerkersovereenkomst</Link>
          <Link to="/privacybeleid" className="hover:underline">Privacybeleid</Link>
        </div>
      </div>
    </div>
  );
};
